import GridItem from "./GridItem";
import CertificatesCard from "./content/CertificatesCard";
import EducationCard from "./content/EducationCard";
import ExperienceCard from "./content/ExperienceCard";
import FooterCard from "./content/FooterCard";
import IntroductionCard from "./content/IntroductionCard";
import ProjectsCard from "./content/ProjectsCard";
import SocialsCard from "./content/SocialsCard";
import ProfilePictureCard from "./content/ProfilePictureCard";

export default function CssGrid() {
  return (
    <div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-5 gap-4 p-4">

        <GridItem className="col-span-1 sm:col-span-2 md:col-span-3 lg:row-span-2">
          <IntroductionCard />
        </GridItem>

        <GridItem className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2 lg:row-span-3 !justify-start !items-start">
          <ExperienceCard />
        </GridItem>

        <GridItem className="col-span-1 sm:col-span-1 lg:col-span-1">
          <SocialsCard />
        </GridItem>

        <GridItem className="hidden sm:flex !overflow-visible sm:col-span-1 lg:col-span-2">
          <ProfilePictureCard />
        </GridItem>

        <GridItem className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-3 lg:row-span-2">
          <CertificatesCard />
        </GridItem>

        <GridItem className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2">
          <EducationCard />
        </GridItem>

        <GridItem className="col-span-1 sm:col-span-2 md:col-span-3 lg:col-span-2">
          <ProjectsCard />
        </GridItem>

        <GridItem className="col-span-full">
          <FooterCard />
        </GridItem>

      </div>
    </div>
  );
}
